let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5BQO3")).then(() => parcelRequire('ljmsu'));